var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.bare && _vm.orderInfo.status >= 4 && (_vm.orderInfo.expressName || _vm.orderInfo.expressNo))?_c('div',{staticClass:"ful-section"},[_vm._t("content")],2):(_vm.bare && _vm.orderInfo.status >= 4 && (_vm.orderInfo.expressName || _vm.orderInfo.expressNo))?_c('div',[_vm._t("content")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }